import { DensitySmall } from '@mui/icons-material'
import { Box } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import IconButton from 'components/icon-button'
import Loading from 'components/loading'
import { IAuthenticationsPermissions } from 'data/dtos/automation/i-authentications-permissions-dto'
import dayjs from 'dayjs'
import { useHistory } from 'react-router-dom'
import { loadList } from 'services/requests'
import TableStatus from '../table-status'
import { useStyles } from './styles'

const InitialTables = () => {
  const classes = useStyles()
  const history = useHistory()

  const { data, isLoading } = useQuery({
    queryKey: ['permissionsList'],
    queryFn: () =>
      loadList('/organizations-permissions/list', {
        search: '',
        page: 0,
        rowsPerPage: 1000,
        columnOrder: [],
        organizationId: '',
      }),
    initialData: { data: { data: [] } } as any,
    select: (data) => data.data.data,
  })

  const permissions: IAuthenticationsPermissions[] = data

  const handleNavigationToTable = (permission: IAuthenticationsPermissions) => {
    const id = `${permission.organizationIdOutput}/${permission.snowflakeTableId}`

    history.push(`/cofre-digital/table/preview/${id}`)
  }

  if (isLoading) {
    return (
      <Box className={classes.root}>
        <Loading />
      </Box>
    )
  }

  return (
    <Box className={classes.root}>
      <table className={classes.tableBase}>
        <thead className={classes.tableHeader}>
          <tr>
            <th className={classes.tableSize}>Nome da Tabela</th>
            <th className={classes.tableSize}>Ultima atualização</th>
            <th className={classes.tableSize}>Status</th>
            <th className={classes.tableActionSize}></th>
          </tr>
        </thead>

        <tbody className={classes.tableBody}>
          {permissions.map((permission, index) => (
            <tr key={index}>
              <td className={classes.tableSize}>
                <span>{permission.name}</span>
              </td>

              <td className={classes.tableSize}>
                {permission.lastUpdate && dayjs(permission.lastUpdate).format('DD/MM/YYYY - HH:mm:ss')}
              </td>

              <td className={classes.tableSize}>
                <TableStatus status={permission.isPermitted ? 'authorized' : 'unauthorized'} />
              </td>

              <td className={classes.tableActionSize}>
                <IconButton
                  icon={DensitySmall}
                  isDisabled={!permission.isPermitted}
                  onClick={() => handleNavigationToTable(permission)}
                  tooltip='Ver Tabelas'
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Box>
  )
}

export default InitialTables
